// extracted by mini-css-extract-plugin
export default {"image":"bobAvatar_image__Bwr0A","size__small":"bobAvatar_size__small__0G6-E","size__medium":"bobAvatar_size__medium__NpAYw","size__large":"bobAvatar_size__large__QTeyS"};